// Helpers for the Outreach settings block: the follow-up days are typed as "4, 7" and stored as [4, 7].
export const parseFollowupDays = (text: string): number[] =>
  text
    .split(/[,\s]+/)
    .map(Number)
    .filter((n) => Number.isInteger(n) && n > 0);

export const formatFollowupDays = (days?: number[]): string =>
  (days ?? []).join(", ");

export const SEND_DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
].map((name, id) => ({ id, name }));

export const validSendHours = (v?: string) =>
  !v || /^\d{2}:\d{2}-\d{2}:\d{2}$/.test(v.trim());

export const validTimezone = (v?: string) => {
  if (!v?.trim()) return true;
  try {
    new Intl.DateTimeFormat("en", { timeZone: v.trim() });
    return true;
  } catch {
    return false;
  }
};

export const validBookingUrl = (v?: string) => {
  if (!v?.trim()) return true;
  try {
    return new URL(v.trim()).protocol === "https:";
  } catch {
    return false;
  }
};

/** The suggested reply offers the booking link to an interested prospect only; no link set, no line */
export const bookingLine = (intent?: string | null, url?: string) =>
  intent === "interested" && url ? `Book a call with us: ${url}` : "";
